export async function retrievUserConfiguration(user_id) {
  const url =
    "https://kesxkrclz0.execute-api.us-east-1.amazonaws.com/Testing/configurations?config_type=unsubmitted";
  // const url = `${baseUrl}?user_id=${encodeURIComponent(user_id)}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${user_id}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(
        `Error retrieving configuration: ${response.status} ${response.statusText}`,
      );
    }

    const data = await response.json();
    // console.log("Configuration retrieved successfully:", data);
    return data;
  } catch (error) {
    console.error("Failed to fetch configuration:", error);
    throw error;
  }
}
